import Header from '../components/Header';
import Footer from '../components/Footer';
import { Shield, Lock, Eye, FileText, Clock } from 'lucide-react';

export default function PrivacyPolicy() {
  const sections = [
    {
      title: '1. Information Collection',
      content: 'We collect information you provide directly to us when you create an account, apply for a loan, or communicate with us. This includes identity data, contact details, financial status, and transactional history.',
      icon: Eye
    },
    {
      title: '2. Data Usage',
      content: 'Your data is primarily used to evaluate creditworthiness, process loan disbursements, prevent fraud, and comply with legal requirements. We do not sell your personal data to third parties.',
      icon: FileText
    },
    {
      title: '3. Security Architecture',
      content: 'We employ enterprise-grade encryption and secure protocol tiers to protect your sensitive data. Our platform is monitored 24/7 for unauthorized access or security breaches.',
      icon: Lock
    },
    {
      title: '4. Your Rights',
      content: 'You have the right to access, correct, or request the deletion of your personal data held by Finova. You can manage your privacy settings directly within your user dashboard.',
      icon: Shield
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Header */}
      <section className="pt-16 pb-16 bg-stripe-bg">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center space-y-6">
           <h1 className="text-4xl md:text-6xl font-black text-stripe-dark tracking-tighter italic">Privacy Policy</h1>
           <p className="text-lg text-stripe-slate font-medium">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 max-w-4xl mx-auto px-4 sm:px-6">
         <div className="space-y-16">
            {sections.map((s, i) => (
              <div key={i} className="flex flex-col md:flex-row gap-8 items-start">
                 <div className="w-12 h-12 bg-primary-50 rounded-2xl flex items-center justify-center text-primary-500 shrink-0 border border-primary-100 shadow-sm">
                    <s.icon size={24} />
                 </div>
                 <div className="space-y-4">
                    <h2 className="text-2xl font-black text-stripe-dark tracking-tight leading-none">{s.title}</h2>
                    <p className="text-stripe-slate text-lg leading-relaxed font-medium">{s.content}</p>
                 </div>
              </div>
            ))}

            <div className="p-12 bg-stripe-bg rounded-[40px] border border-stripe-border mt-12">
               <div className="flex items-center gap-4 mb-6">
                  <Clock size={20} className="text-primary-500" />
                  <h3 className="text-xl font-black text-stripe-dark italic tracking-tight">Data Retention</h3>
               </div>
               <p className="text-sm text-stripe-slate leading-relaxed font-medium">
                 Finova retains user data as long as necessary to provide services and as required for legal/regulatory compliance. Financial transaction records are maintained for a minimum of 7 years in accordance with local financial regulations.
               </p>
            </div>
         </div>
      </section>

      <Footer />
    </div>
  );
}
